function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1429 13.9091H46.4551C46.7564 13.9091 47 14.1533 47 14.4545C47 14.7558 46.7558 15 46.4545 15H39.5455C39.2442 15 39 14.7558 39 14.4545C39 14.1533 39.2437 13.9091 39.5449 13.9091H41.8571C42.5528 13.9091 42.7143 10.3636 42.4286 10.3636H41.0729C40.6963 10.3636 40.3913 10.0584 40.3913 9.68182C40.3913 9.30526 40.6966 9 41.0731 9H44.8896C45.2662 9 45.5714 9.30526 45.5714 9.68182C45.5714 10.0584 45.2665 10.3636 44.8899 10.3636H43.5714C43.2857 10.3636 43.6791 13.9091 44.1429 13.9091Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1429 13.9091H16.4551C16.7564 13.9091 17 14.1533 17 14.4545C17 14.7558 16.7558 15 16.4545 15H9.54545C9.24421 15 9 14.7558 9 14.4545C9 14.1533 9.24369 13.9091 9.54493 13.9091H11.8571C12.5528 13.9091 12.7143 10.3636 12.4286 10.3636H11.0729C10.6963 10.3636 10.3913 10.0584 10.3913 9.68182C10.3913 9.30526 10.6966 9 11.0731 9H14.8896C15.2662 9 15.5714 9.30526 15.5714 9.68182C15.5714 10.0584 15.2665 10.3636 14.8899 10.3636H13.5714C13.2857 10.3636 13.6791 13.9091 14.1429 13.9091Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9L7.50571 3.42322L3.42322 7.50571L9 9ZM0.646447 1.35355L5.46447 6.17157L6.17157 5.46447L1.35355 0.646447L0.646447 1.35355Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 19,
  y1: 14.5,
  x2: 37,
  y2: 14.5,
  stroke: "white"
});

var SvgLeftOuterButton = function SvgLeftOuterButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 15,
    viewBox: "0 0 47 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftOuterButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftOuterButton.27685873.svg";
export { ForwardRef as ReactComponent };